module.exports = __webpack_public_path__ + "img/bg.d5f638c9.jpg";